<template>
  <!-- 详情页 -->
  <section>
    <!-- 面包屑导航 -->
    <div class="cet">
      <b-container fluid>
        <b-row class="justify-content-center newsDetail">
          <b-col cols="12" sm="10" md="9" xl="7">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item
                ><a @click="goBackNewCenter">中心动态</a></el-breadcrumb-item
              >
              <el-breadcrumb-item>详情</el-breadcrumb-item>
            </el-breadcrumb>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <!-- 正文部分 -->
    <b-container fluid>
      <b-row class="justify-content-center newsDetail">
        <b-col cols="12" sm="10" md="9" xl="7">
          <!-- 新闻详情部分 -->
          <div id="newsDetail">
            <!-- 新闻有关的 -->
            <div class="newsAbout">
              <!-- 一级标题 -->
              <h2 class="primaryTitle">{{ form.name }}</h2>
              <!-- 发布时间 -->
              <p class="releaseTime">发布：{{ form.time }}</p>
              <!-- 分享 -->
              <div
                class="mobileShare"
                @click="showShare = !showShare"
                v-show="!showShare"
              >
                分享
              </div>
              <div class="share" v-show="showShare">
                <div>
                  <span class="shareText">分享</span>
                  <span class="weibo" @click="shareNews('weiBo', form)"></span>
                  <span
                    class="weChat"
                    @click="shareNews('weChat', form)"
                  ></span>
                  <span
                    class="friend"
                    @click="shareNews('friend', form)"
                  ></span>
                  <span class="QQ" @click="shareNews('qq', form)"></span>
                </div>
              </div>
              <!-- 二级标题 -->
              <!-- <h3 class="subTitle">{{ data.subTitle }}</h3> -->
              <!-- 详情正文与配图循环展示 -->
              <h4 class="outUrl" v-if="form.url">
                文章引入外部链接，
                <span @click="goOutUrl(form)"
                  ><i class="el-icon-link"></i>点击链接</span
                >
                查看更多内容
              </h4>
              <div
                v-for="item in form.paragraphVoList"
                :key="item.id"
                class="p-content"
                v-else
              >
                <p
                  class="hPre"
                  v-if="item.size == 18"
                  :class="{
                    textBold: item.isBold == '1',
                    textIndentation: item.alignment == '0',
                    textLeft: item.alignment == '1',
                    textCenter: item.alignment == '2',
                    textRight: item.alignment == '3',
                  }"
                >
                  <!-- :style="{ fontSize: item.size + 'px' }" -->
                  {{ item.content }}
                </p>
                <p
                  v-else-if="item.size == 17"
                  class="hPre1"
                  :class="{
                    textBold: item.isBold == '1',
                    textIndentation: item.alignment == '0',
                    textLeft: item.alignment == '1',
                    textCenter: item.alignment == '2',
                    textRight: item.alignment == '3',
                  }"
                >
                  <!-- :style="{ fontSize: item.size + 'px' }" -->
                  {{ item.content }}
                </p>
                <p
                  v-else
                  class="noHpre"
                  :class="{
                    textBold: item.isBold == '1',
                    textIndentation: item.alignment == '0',
                    textLeft: item.alignment == '1',
                    textCenter: item.alignment == '2',
                    textRight: item.alignment == '3',
                  }"
                >
                  <!-- :style="{ fontSize: item.size + 'px' }" -->
                  {{ item.content }}
                </p>
                <div class="newsImg" v-if="item.imgSrc">
                  <img :src="item.imgSrc" alt="" />
                </div>
                <div class="newsImg" v-if="item.videoSrc">
                  <!-- <video
                controls
                :src="item.videoSrc"
              ></video>     -->
                  <div id="playVideoWindow">
                    <video
                      v-if="videoPlayers"
                      ref="vdo"
                      id="playVideo"
                      class="video-js vjs-default-skin vjs-big-play-centered vjs-fluid"
                      preload="auto"
                      width="100%"
                      style="object-fit: cover;"
                    ></video>
                  </div>
                </div>
              </div>
              <!-- 详情正文 -->
              <!-- <p class="newsContent">{{ newsContent }}</p> -->
              <!-- 配图 -->
              <!-- <div class="newsImg">
                <img :src="img" alt="" />
              </div> -->
              <!-- 配图标注 -->
              <!-- <p class="imgDesc">{{ description }}</p> -->
              <!-- 撰文人 -->
              <p class="write" v-if="form.author">撰文 | {{ form.author }}</p>
              <!-- 编辑人 -->
              <p class="edit" v-if="form.editor">编辑 | {{ form.editor }}</p>
              <!-- <p class="downP">
                <span class="title">下载附件：</span>
                <span
                  class="name"
                  v-for="itemDown in downData"
                  :key="itemDown.id"
                  >{{ itemDown.name }}</span
                >
              </p> -->
              <!-- 下载链接表格 -->
              <ul
                class="downloadList"
                v-if="form.fileList && form.fileList.length"
              >
                <li class="downTitle">附件列表</li>
                <li
                  class="downItem"
                  v-for="downItem in form.fileList"
                  :key="downItem.id"
                >
                  <span @click="downLoad(downItem)">
                    {{ downItem.fileTitle }}
                  </span>
                </li>
              </ul>
            </div>
            <!-- 上下篇新闻 -->
            <div class="newsUpAndDown" v-if="papers.length > 1">
              <div
                style="border-left: 3px solid #066bf3; padding: 3px 5px"
                class="more-btn"
              >
                更多
              </div>
              <div
                class="item-btn"
                @click="dumpNews('prev')"
                v-if="currentPaperIndex > 0"
              >
                上一篇: {{ papers[currentPaperIndex - 1].name }}
              </div>
              <div
                class="item-btn"
                @click="dumpNews('next')"
                v-if="currentPaperIndex + 1 < papers.length"
              >
                下一篇: {{ papers[currentPaperIndex + 1].name }}
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
// import QRCode from "qrcodejs2";
import QRCode from "qrcode2";
import axios from "axios";
import qs from "qs";
import utils from "@/utils/commonUrl.js";
import "video.js/dist/video-js.css";
import videojs from "video.js";
import "videojs-contrib-hls";
export default {
  data() {
    return {
      videoPlayers: "",
      playVideoUrL: utils.videoUrl,
      data: [],
      form: {
        name: "",
        author: "",
        time: "",
        fileIds: [],
        fileCoverId: "",
        introduction: "",
        paragraphVoList: [
          // {
          //   alignment: "",
          //   size: "",
          //   content: "",
          //   fileId: "",
          //   isBold: "",
          //   num: 0,
          // },
        ],
      },
      // logOn: "",
      showShare: false,
      detailId: "",
      downData: [
        { id: 1, name: "下载附件一.pdf" },
        { id: 2, name: "下载附件二.docx" },
        { id: 3, name: "下载附件三.xlsx" },
      ],
      papers: [],
      currentPaperIndex: 0,
      queryInfo: {
        currentPage: 1,
      },
    };
  },
  watch: {},
  created() {},
  beforeDestroy() {
    let that = this;
    if(that.videoPlayers){
      that.videoPlayers.dispose();
    }
  },
  mounted() {
    var that = this;
    that.detailId = this.$route.query.id;
    that.getDetailData(this.detailId);
    this.getNewsList();
    // 移动端滑动屏幕时,隐藏分享框,只展示分享按钮
    document.addEventListener("touchmove", function () {
      console.log("触摸");
      that.showShare = false;
    });
    // 窗口大小发生改变时,调用一次
    window.onresize = () => {
      let screenWidth = window.innerWidth;
      that.setReSize(screenWidth);
    };
    that.setReSize(window.innerWidth);
  },
  methods: {
    setReSize(screenWidth) {
      var isMobile = this.isMobile();
      if (isMobile == "mobile" && screenWidth < 576) {
        this.showShare = false;
      } else {
        this.showShare = true;
      }
    },
    dumpNews(val) {
      console.log("233", val, this.tempList);

      if (val === "prev") {
        this.currentPaperIndex -= 1;
      } else {
        this.currentPaperIndex += 1;
      }
      if (this.currentPaperIndex === this.papers.length - 1) {
        this.queryInfo.currentPage += 1;
        this.getNewsList();
      }
      // if (!this.papers[this.currentPaperIndex].url) {
      //   let routeData = "";
      //   routeData = this.$router.resolve({
      //     path: "/about-us/new-detail",
      //     query: {
      //       id: this.papers[this.currentPaperIndex].id,
      //     },
      //   });
      //   window.open(routeData.href, "_blank");
      // }
      this.$router.push({
        path: "/about-us/new-detail",
        query: {
          id: this.papers[this.currentPaperIndex].id,
        },
      });
    },
    goOutUrl(val) {
      let urlStr = "";
      urlStr = val.url.indexOf("http") == -1 ? "https://" + val.url : val.url;
      window.open(urlStr);
    },
    async getDetailData(detailId) {
      try {
        let { data: res } = await this.$http.get(
          "/server/api/content/news/website/search/getInfo",
          {
            params: {
              id: detailId,
            },
          }
        );

        if (res.code == 200) {
          this.form.id = res.content.id;
          this.form.name = res.content.name;
          this.form.url = res.content.url;
          this.form.author = res.content.author;
          this.form.fileCoverId = res.content.fileCoverId;
          this.form.introduction = res.content.introduction;
          this.form.time = this.formate_Date(res.content.time);
          this.form.paragraphVoList = res.content.paragraphVoList;
          this.form.fileList = res.content.fileList;
          this.form.paragraphVoList.forEach((val, i) => {
            val.alignment = val.alignment + "";
            if (val.fileId.length > 0) {
              let srcPic =
                utils.imgURL +
                "/server/api/system/file/getFile?id=" +
                val.fileId;
              let srcVideo =
                utils.imgURL +
                "/server/api/system/file/getFile?id=" +
                val.fileId;
              if (val.fileType != ".mp4") {
                val.imgSrc = srcPic;
              } else {
                this.bofang(val.fileTitle);
                val.videoSrc = srcVideo;
              }
            }
            // console.log("rer",typeof val.alignment,val.alignment)
          });

          // console.log("res.con", res.content);
        }
      } catch (e) {}
    },
    bofang(fileTitle) {
      var that = this;
      that.$nextTick(() => {
        // 加载视频
        // let v_src = that.playVideoUrL + "/banner.m3u8";
        let v_src = that.playVideoUrL +"/" + fileTitle + ".m3u8";
        let options = {
          autoplay: true,
          controls: true,
          // loop: true,
          muted: true,
          // width: window.innerWidth * 0.46,
          // height: 300,
        };
        $("#playVideoWindow").html(
          ` <video ref="vdo" width="100%" style="object-fit: cover;" id="playVideo" class="video-js vjs-default-skin vjs-big-play-centered vjs-fluid" preload="auto"  v-if="videoPlayers"></video>`
        );
        that.videoPlayers = videojs("playVideo", options);
        that.videoPlayers.src({ src: v_src, type: "application/x-mpegURL" });
        // that.videoPlayers.ready(() => {
        //     that.videoPlayers.src({ src: v_src, type: "application/x-mpegURL" });
        // });
        // that.$forceUpdate()
      });
    },

    async downLoadPdf(fileName, id) {
      try {
        const { data: res } = await this.$http.get(
          "/server/api/system/file/getFile?id=" + id,
          {
            // responseType: "arraybuffer",
            responseType: "blob",
          }
        );
        if (res) {
          if (fileName.indexOf(".pdf") != -1) {
            const blob = new Blob([res], {
              type: "application/pdf;",
            });
            const objectUrl = URL.createObjectURL(blob);
            window.location.href = objectUrl;
          }
          this.$utils.downloadExcel(res, fileName);
        }
      } catch (e) {}
    },
    downLoad(val) {
      const addTypeArray = val.fileType.split(".");
      const addType = addTypeArray[addTypeArray.length - 1];
      if (
        addType === "doc" ||
        addType === "docx" ||
        addType === "xls" ||
        addType === "xlsx" ||
        addType === "mp4"
      ) {
        window.open(
          utils.imgURL + "/server/api/system/file/getFile?id=" + val.id
        );
      } else if (addType === "pdf") {
        this.downLoadPdf(val.fileTitle, val.id);
      }
    },
    formate_Date(time) {
      time = new Date(time);
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let day = time.getDate();

      if (month < 10) {
        month = "0" + month;
      }

      if (day < 10) {
        day = "0" + day;
      }
      return year + "-" + month + "-" + day + "";
    },
    //获取新闻列表
    async getNewsList() {
      console.log("iii");
      try {
        let { data: res } = await this.$http.get(
          "/server/api/content/news/website/search/getPageList",
          {
            params: {
              currentPage: this.queryInfo.currentPage,
              pageSize: 10,
            },
          }
        );

        if (res.code === 200) {
          let tempList = !res.content ? [] : res.content.list;
          if (tempList.length === 0) {
            return;
          }
          this.papers = this.papers.concat(tempList);
          let paperInCurrentPage = false;
          this.papers.forEach((item, index) => {
            if (item.id == this.$route.query.id) {
              paperInCurrentPage = true;
              this.currentPaperIndex = index;
            }
          });
          console.log("this", this.$route.query.id, !paperInCurrentPage);
          if (
            this.$route.query.id != undefined &&
            (!paperInCurrentPage ||
              this.currentPaperIndex == this.papers.length - 1)
          ) {
            this.queryInfo.currentPage += 1;
            await this.getNewsList();
          }
        }
      } catch (error) {
        return false;
      }
    },
    //返回中心动态
    goBackNewCenter() {
      this.$router.push("/about-us/new-center");
    },
    //分享功能
    shareNews(target, data) {
      console.log("target", target);
      console.log(encodeURIComponent(document.location), window.location.href);
      let logOn = this.isMobile();
      //是移动端
      if (logOn === "mobile") {
        this.$Share.setShareData({
          icon:
            utils.imgURL +
            "/server/api/system/file/getFile?id=" +
            data.fileCoverId,
          link: window.location.href,
          title: data.name,
          desc: data.introduction,
          form: "@icenter",
        });
        // console.log(11);
        if (target === "weiBo") {
          try {
            this.$Share.call("weibo");
          } catch (err) {
            // this.$message.warning("应用唤醒失败,推荐使用浏览器自带的分享功能");
            this.$bvToast.toast("应用唤醒失败,推荐使用浏览器自带的分享功能", {
              autoHideDelay: 3000,
              toaster: "b-toaster-bottom-center",
              solidProp: 100,
              appendToast: false,
              noCloseButton: true,
            });
          }
        } else if (target === "weChat") {
          try {
            this.$Share.call("wechatFriend");
            // this.$bvToast.toast("应用唤醒失败,推荐使用浏览器自带的分享功能", {
            //   autoHideDelay: 20000,
            //   toaster: "b-toaster-bottom-center",
            //   appendToast: false,
            //   noCloseButton: true,
            //   solidProp: true,
            // });
          } catch (err) {
            // this.$message.warning("应用唤醒失败,推荐使用浏览器自带的分享功能");
            this.$bvToast.toast("应用唤醒失败,推荐使用浏览器自带的分享功能", {
              autoHideDelay: 3000,
              toaster: "b-toaster-bottom-center",
              appendToast: false,
              noCloseButton: true,
              solidProp: 100,
            });
          }
        } else if (target === "friend") {
          try {
            this.$Share.call("wechatTimeline");
          } catch (err) {
            this.$bvToast.toast("应用唤醒失败,推荐使用浏览器自带的分享功能", {
              autoHideDelay: 3000,
              toaster: "b-toaster-bottom-center",
              solidProp: 100,
              appendToast: false,
              noCloseButton: true,
            });
          }
        } else if (target === "qq") {
          try {
            this.$Share.call("qqFriend");
            //
          } catch (err) {
            this.$bvToast.toast("应用唤醒失败,推荐使用浏览器自带的分享功能", {
              autoHideDelay: 3000,
              toaster: "b-toaster-bottom-center",
              solidProp: 100,
              appendToast: false,
              noCloseButton: true,
            });
          }
        }
      } else if (logOn === "PC") {
        //PC
        if (target === "weiBo") {
          let weiBoUrl = encodeURIComponent(document.location);
          let name = data.name;
          let picUrl =
            utils.imgURL +
            "/server/api/system/file/getFile?id=" +
            data.fileCoverId;
          console.log(weiBoUrl, "+++++++", picUrl);
          let shareWeiBo = `http://service.weibo.com/share/share.php?title=${name}&url=${weiBoUrl}&content=utf-8&sourceUrl=&pic=${picUrl}`;
          // let shareWeiBo = `http://v.t.sina.com.cn/share/share.php?title=${name}&url=${weiBoUrl}&content=utf-8&sourceUrl=&pic=${picUrl}`;
          window.open(shareWeiBo);
        } else if (target === "weChat") {
          this.$alert(
            `<div>
              <h3
                style="
                  height: 63px;
                  font-size: 18px;
                  line-height: 2;
                  text-align: center;
                "
              >
                分享至微信
              </h3>
              <div id="qrcode" ref="qrcode"></div>
              <p>
                打开微信，使用“扫一扫”功能，
              </p>
              <p>
                即可将本文内容分享至微信好友或朋友圈
              </p>
            </div>`,
            "",
            {
              closeOnClickModal: true,
              dangerouslyUseHTMLString: true,
              showClose: false,
              showConfirmButton: false,
            }
          ).then(
            () => {
              console.log("关闭弹窗1");
            },
            () => {
              console.log("关闭弹窗2");
              let qrcode = document.getElementById("qrcode");
              qrcode.innerHTML = "";
            }
          );

          this.$nextTick(() => {
            var qrcode = new QRCode("qrcode", {
              // var qrcode = new QRCode(document.getElementById("qrcode"), {
              width: 215,
              // render:'canvas',
              height: 215,
              // colorDark : "#000",
              // colorLight : "#fff",
              // correctLevel : QRCode.CorrectLevel.H,
              text: document.location.href,
              // text: encodeURIComponent(document.location.href),
              // text: encodeURIComponent(document.location),
            });

            // console.log(qrcode);
          });
        } else if (target === "friend") {
          // let url = encodeURIComponent(document.location);
          // let shareF = `http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=${url}`;
          // window.open(shareF);
          this.$alert(
            `<div>
              <h3
                style="
                  height: 63px;
                  font-size: 18px;
                  line-height: 2;
                  text-align: center;
                "
              >
                分享至微信
              </h3>
              <div id="qrcode" ref="qrcode"></div>
              <p>
                打开微信，使用“扫一扫”功能，
              </p>
              <p>
                即可将本文内容分享至微信好友或朋友圈
              </p>
            </div>`,
            "",
            {
              closeOnClickModal: true,
              dangerouslyUseHTMLString: true,
              showClose: false,
              showConfirmButton: false,
            }
          ).then(
            () => {
              console.log("关闭弹窗1");
            },
            () => {
              console.log("关闭弹窗2");
              let qrcode = document.getElementById("qrcode");
              qrcode.innerHTML = ""; //parentNode.removeChild(qrcode);
            }
          );
          this.$nextTick(() => {
            let qrcode = new QRCode("qrcode", {
              width: 215,
              height: 215,
              text: document.location.href,
              // text: encodeURIComponent(document.location),
            });
            // console.log(qrcode);
          });
        } else if (target === "qq") {
          var url = document.location.href; //"https://music.163.com/";
          // var url = encodeURIComponent(document.location.href); //"https://music.163.com/";
          var name = data.name;
          let picUrl =
            utils.imgURL +
            "/server/api/system/file/getFile?id=" +
            data.fileCoverId;
          // let QQshare = `http://connect.qq.com/widget/shareqq/index.html?url=${url}&title=${name}&pics=${picUrl}`;
          // let QQshare = `https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=${url}&title=${name}`;//分享到qq空间
          let QQshare = `http://connect.qq.com/widget/shareqq/iframe_index.html?url=${url}`;
          console.log("kk", QQshare);
          window.open(QQshare);
        }
      }
    },
    //判断为PC还是移动端
    isMobile() {
      var sUserAgent = navigator.userAgent.toLowerCase();
      var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
      var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
      var bIsMidp = sUserAgent.match(/midp/i) == "midp";
      var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
      var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
      var bIsAndroid = sUserAgent.match(/android/i) == "android";
      var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
      var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
      if (
        bIsIpad ||
        bIsIphoneOs ||
        bIsMidp ||
        bIsUc7 ||
        bIsUc ||
        bIsAndroid ||
        bIsCE ||
        bIsWM
      ) {
        return "mobile";
        // alert("移动端设备");
      } else {
        // alert("pc端设备");
        return "PC";
      }
    },
  },
  goOutUrl(val) {
    let urlStr = "";
    urlStr = val.url.indexOf("http") == -1 ? "https://" + val.url : val.url;
    window.open(urlStr);
  },
};
</script>

<style scoped>
@import "../../assets/css/newDetail.css";
</style>
<style lang="less" scoped>
@media (max-width: 575px) {
  .cet {
    padding-left: 20px;
  }
  .newsAbout {
    padding: 50px 40px 30px;
    .primaryTitle {
      font-size: 17px;
      margin-bottom: 12px;
    }
    .outUrl {
      font-size: 14px;
      margin-bottom: 10px;
    }
    .releaseTime {
      font-size: 13px;
    }
    .mobileShare {
      position: fixed;
      right: 0px;
      bottom: 3%;
      background-color: white;
      border-radius: 50%;
      box-shadow: 0 0 3px #bfbfbf;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      width: 40px;
      height: 40px;
      z-index: 9;
    }
    .share {
      margin: 20px 0;
      transform: scale(0.7);
      right: 0px;
    }
    .subTitle {
      font-size: 14px;
    }
    .p-content {
      line-height: 2.2;
    }
    .hPre {
      font-size: 16px;
    }
    .hPre1 {
      font-size: 15px;
    }
    .noHpre {
      font-size: 14px;
    }
    .newsImg {
      // height: 200px;
    }
    .imgDesc {
      font-size: 12px;
      line-height: 2;
      margin-bottom: 20px;
    }
    .write,
    .edit {
      font-size: 13px;
      line-height: 2;
    }
  }
  .newsUpAndDown {
    padding: 20px 10px 30px;
    .item-btn {
      line-height: 1.5;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 14px;
      color: #333;
      font-family: "PingFangSC-regular";
      cursor: pointer;
      padding: 10px 0 15px;
      border-bottom: 2px solid #eee;
    }
  }
  .more-btn {
    font-size: 15px;
  }
}
@media (min-width: 576px) and (max-width: 767px) {
  .newsAbout {
    padding: 50px 0 30px;
    .primaryTitle {
      font-size: 18px;
      margin-bottom: 12px;
    }
    .outUrl {
      font-size: 15px;
      margin-bottom: 10px;
    }
    .releaseTime {
      font-size: 14px;
    }
    .mobileShare {
      position: fixed;
      right: 0px;
      bottom: 3%;
      background-color: white;
      border-radius: 50%;
      box-shadow: 0 0 3px #bfbfbf;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      width: 40px;
      height: 40px;
      z-index: 9;
    }
    .share {
      margin: 20px 0;
      transform: scale(0.8, 0.8);
    }
    .subTitle {
      font-size: 16px;
    }
    .p-content {
      line-height: 2.3;
    }
    .hPre {
      font-size: 17px;
    }
    .hPre1 {
      font-size: 16px;
    }
    .noHpre {
      font-size: 15px;
    }
    .newsImg {
      // height: 250px;
    }
    .imgDesc {
      font-size: 14px;
      line-height: 2;
      margin-bottom: 20px;
    }
    .write,
    .edit {
      font-size: 14px;
      line-height: 2;
    }
  }
  .newsUpAndDown {
    padding: 20px 0 40px;
    .item-btn {
      line-height: 1.8;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 15px;
      color: #333;
      font-family: "PingFangSC-regular";
      cursor: pointer;
      border-bottom: 2px solid #eee;
    }
  }
  .more-btn {
    font-size: 16px;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .newsAbout {
    padding: 50px 0 30px;
    .primaryTitle {
      font-size: 20px;
      margin-bottom: 14px;
    }
    .outUrl {
      font-size: 16px;
      margin-bottom: 10px;
    }
    .releaseTime {
      font-size: 14px;
    }
    .mobileShare {
      position: fixed;
      right: 0px;
      bottom: 3%;
      background-color: white;
      border-radius: 50%;
      box-shadow: 0 0 3px #bfbfbf;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      width: 40px;
      height: 40px;
      z-index: 9;
    }
    .share {
      margin: 20px 0;
      transform: scale(0.9, 0.9);
    }
    .subTitle {
      font-size: 18px;
    }
    .p-content {
      line-height: 2.3;
    }
    .hPre {
      font-size: 18px;
    }
    .hPre1 {
      font-size: 17px;
    }
    .noHpre {
      font-size: 16px;
    }
    .newsImg {
      // height: 250px;
    }
    .imgDesc {
      font-size: 16px;
      line-height: 2;
      margin-bottom: 20px;
    }
    .write,
    .edit {
      font-size: 15px;
      line-height: 2;
    }
  }
  .newsUpAndDown {
    padding: 20px 0 30px;
    .item-btn {
      line-height: 2;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 15px;
      color: #333;
      font-family: "PingFangSC-regular";
      cursor: pointer;
      border-bottom: 2px solid #eee;
    }
  }
  .more-btn {
    font-size: 16px;
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .newsAbout {
    padding: 50px 0 30px;
    .primaryTitle {
      font-size: 22px;
      margin-bottom: 14px;
    }
    .outUrl {
      font-size: 18px;
      margin-bottom: 10px;
    }
    .releaseTime {
      font-size: 15px;
    }
    .mobileShare {
      position: fixed;
      right: 0px;
      bottom: 3%;
      background-color: white;
      border-radius: 50%;
      box-shadow: 0 0 3px #bfbfbf;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      width: 40px;
      height: 40px;
      z-index: 9;
    }
    .share {
      margin: 20px 0;
      transform: scale(0.9, 0.9);
    }
    .subTitle {
      font-size: 20px;
    }
    .p-content {
      line-height: 2.4;
    }
    .hPre {
      font-size: 18px;
    }
    .hPre1 {
      font-size: 17px;
    }
    .noHpre {
      font-size: 16px;
    }
    .newsImg {
      // height: 350px;
    }
    .imgDesc {
      font-size: 18px;
      line-height: 2;
      margin-bottom: 20px;
    }
    .write,
    .edit {
      font-size: 17px;
      line-height: 2;
    }
  }
  .newsUpAndDown {
    padding: 20px 0 30px;
    .item-btn {
      line-height: 2;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 16px;
      color: #333;
      font-family: "PingFangSC-regular";
      cursor: pointer;
      padding: 10px 0 15px;
      border-bottom: 2px solid #eee;
    }
  }
  .more-btn {
    font-size: 17px;
  }
}
@media (min-width: 1200px) {
}
</style>
